<template>
  <div id="fichaConsumo">
    <div v-for="p in fichas">
      <br><br>
      <div style="text-align: center">
        <b>{{p.empresa}}</b>
        <div>#{{p.id_comanda_produto | id_cp}} - FICHA DE CONSUMO</div>
        <small>[Venda {{p.id_venda}} | {{p.data_comanda}}]</small>
        <div v-if="p.mesa || p.ref_comanda">
          <span v-if="p.mesa">Mesa: {{p.mesa}}</span>
          <span v-else-if="p.ref_comanda">Comanda: {{p.ref_comanda}}</span>
        </div>
      </div>
      <br>
      <div><b># {{p.nome_produto}}</b></div>
      <div v-for="a in p.adicionais">
        + {{(a.quantidade / p.quantidade) | qtd}} {{a.nome_produto}}
      </div>
      <br><br><hr data-cut="true">
    </div>
  </div>
</template>

<script>
export default {
  name: "FichasConsumo",
  props: ['fichas'],

  filters: {
    qtd(value) {
      if (value && !isNaN(value)) {
        let qtd = parseFloat(value && !isNaN(value) ? value : '1');
        return qtd > 1 ? (qtd.toFixed() + 'x') : '';
      }
    },

    id_cp(value) {
      return value ? value.slice(-4) : ''
    }
  }
}
</script>

<style scoped>
</style>